<mat-toolbar class="footer-comp {{displayClass}}">
    <div class="footer-links">

        @for(item of footerComponentLinks; track item){
        @if(item.navigationType != 'webLink'){
        <nuc-link-button styleClass="footer-link-button {{displayClass}}-footerLinks" text="{{item.name}}"
            (click)="onClick(item)" [target]="item.type" data-aue-type="component"
            [attr.data-aue-resource]="item?.cqPath ? (item.cqPath.startsWith('urn:aemconnection:') ? item.cqPath : 'urn:aemconnection:' + item.cqPath) : null"
            data-aue-model="lpmi/components/common/footer-links" data-aue-label="FooterLinks"></nuc-link-button>
        }
        @else{

            @if(item.category == "cookie-policy"){
                <nuc-link-button styleClass="footer-link-button {{displayClass}}-footerLinks" text="{{item.name}}" href="{{item.link}}"
                [target]="item.type" (click)="onClick(item, $event)" 
                data-aue-type="component"
                [attr.data-aue-resource]="item?.cqPath ? (item.cqPath.startsWith('urn:aemconnection:') ? item.cqPath : 'urn:aemconnection:' + item.cqPath) : null"
                data-aue-model="lpmi/components/common/footer-links" 
                data-aue-label="FooterLinks"></nuc-link-button>
            }
            @else{
                <nuc-link-button styleClass="footer-link-button {{displayClass}}-footerLinks" text="{{item.name}}" href="{{item.link}}"
                [target]="item.type" 
                data-aue-type="component"
                [attr.data-aue-resource]="item?.cqPath ? (item.cqPath.startsWith('urn:aemconnection:') ? item.cqPath : 'urn:aemconnection:' + item.cqPath) : null"
                data-aue-model="lpmi/components/common/footer-links" 
                data-aue-label="FooterLinks"></nuc-link-button>
            }
        
        }
        }

    </div>
    <div class="stella-copy-right" data-aue-type="component" data-aue-model="lpmi/components/common/footer"
        data-aue-label="copyRight" [attr.data-aue-resource]="copyRightAueResource">
        <span data-aue-prop="label" data-aue-type="text" data-aue-label="copyRight">{{(pageContent | contentFilter:
            LABELS.COPYRIGHT_TEXT || '© 2024 Stellantis')}}</span>
    </div>
</mat-toolbar>